module.exports = __webpack_public_path__ + "img/geofisica_3-4_512.b3c125ea.jpg";